import * as React from "react";
const SvgFiRrAddressCard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-address-card_svg__a)">
      <path
        fill="#062147"
        d="M24 4v16c0 2.206-1.794 4-4 4h-3a1 1 0 0 1 0-2h3c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-3a1 1 0 0 1 0-2h3c2.206 0 4 1.794 4 4m-7.015 10.45-5.293 5.272a2.68 2.68 0 0 1-1.907.778c-.369 0-.744-.072-1.104-.221-1.033-.425-1.677-1.352-1.681-2.418V16H3c-1.654 0-3-1.346-3-3v-2c0-1.654 1.346-3 3-3h4V6.141c.005-1.07.649-1.997 1.682-2.421 1.055-.433 2.238-.215 3.012.559l5.29 5.267a3.47 3.47 0 0 1 0 4.903zm-1.414-3.488-5.29-5.267c-.245-.245-.593-.224-.838-.125-.132.055-.441.22-.442.576V9a1 1 0 0 1-1 1H3c-.551 0-1 .449-1 1v2c0 .551.449 1 1 1h5a1 1 0 0 1 1 1v2.857c.001.353.31.519.442.573.244.101.593.122.836-.123l5.293-5.272a1.47 1.47 0 0 0 0-2.073"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-address-card_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAddressCard;
